import { AlignRow } from '@framework/ui/components/row/AlignRow.tsx';
import { Button, message } from 'antd';
import { useCallback, useMemo } from 'react';
import { RichTextAdvancedRender } from '../../../../../inputs/rich-text-advanced/render/RichTextAdvancedRender.tsx';
import { InputMarginContainer } from '../../../../../ui/row/InputMarginContainer.tsx';
import { useWidgetEnabled } from '../../../hooks/useWidgetEnabled.ts';
import { useWidgetVisibility } from '../../../hooks/useWidgetVisibility.ts';
import { type IWidgetComponentProps } from '../../../IWidgetType.ts';
import { getWidgetProps } from '../../inputs/common/util/getWidgetProps.ts';
import { ButtonActionLogicSwitch } from './actions/ButtonActionLogicSwitch.tsx';
import { createButtonActionSubject } from './actions/ButtonActionSubject.ts';
import { type IButtonWidget } from './IButtonWidget.ts';
import { getIconFromType } from './icons/Icons.tsx';

export interface IButtonWidgetComponentProps
  extends IWidgetComponentProps<IButtonWidget> {}

export function ButtonWidgetComponent(props: IButtonWidgetComponentProps) {
  const { widget } = props;

  const options = getWidgetProps(props);
  const visible = useWidgetVisibility(props.widget, options);
  const enabled = useWidgetEnabled(widget, options);

  // Hook di antd necessario per gestire i messaggi
  // di loading durante le azioni di richiamo servizio
  const [messageApi, contextHolder] = message.useMessage();

  const buttonClickSubject = useMemo(() => createButtonActionSubject(), []);

  const handleClick = useCallback(() => {
    buttonClickSubject.next({});
  }, [buttonClickSubject]);

  if (!visible) return null;
  if (props.readonly) return null;

  return (
    <>
      {contextHolder}
      <InputMarginContainer>
        {widget.actions?.map((action, index) => (
          <ButtonActionLogicSwitch
            action={action}
            buttonWidgetOptions={options}
            onClickSubject={buttonClickSubject}
            key={index}
            widget={widget}
            index={index}
            messageApi={messageApi}
          />
        ))}
        <AlignRow justify={widget.layout?.buttonAlign ?? 'flex-end'}>
          <Button
            size="large"
            block
            type={widget.layout?.buttonType ?? 'primary'}
            icon={getIconFromType(widget.layout?.iconType)}
            disabled={enabled === false}
            onClick={handleClick}
          >
            <RichTextAdvancedRender inline text={widget.label} />
          </Button>
        </AlignRow>
      </InputMarginContainer>
    </>
  );
}
